<script setup>
import { useOrderStore } from '~/store/order'

const { t } = useI18n()
const order = useOrderStore()
const route = useRoute()
const router = useRouter()
const params = ref({})
const tabs = computed(() => {
  return [
    {
      title: t('当前委托'),
      key: 'open',
      component: defineAsyncComponent(() => import('@/components/orders/spot/Open.vue')),
      props: { params: params.value },
    },
    {
      title: t('历史委托'),
      key: 'close',
      component: defineAsyncComponent(() => import('@/components/orders/spot/Close.vue')),
      props: { params: params.value },
    },
    {
      title: t('成交明细'),
      key: 'detail',
      component: defineAsyncComponent(() => import('@/components/orders/spot/Detail.vue')),
      props: { params: params.value },
    },
    {
      title: t('资金流水'),
      key: 'record',
      component: defineAsyncComponent(() => import('@/components/orders/spot/Record.vue')),
    },
  ]
})

const curTab = computed(() => route.params.type || 'open')

const selects = {
  open: ['baseCurrency', 'quoteCurrency', 'ordType', 'side', 'cancelAll'],
  close: ['baseCurrency', 'quoteCurrency', 'ordType', 'side'],
  detail: ['baseCurrency', 'quoteCurrency', 'side'],
  record: [],
}

function tabChange(type) {
  order.$reset()
  router.replace({ params: { type } })
}

function handleSearch(searchParams) {
  const { baseCurrency, quoteCurrency } = searchParams
  params.value = { ...searchParams, symbol: baseCurrency ? `${baseCurrency}${quoteCurrency || ''}` : '' }
}
</script>

<template>
  <div>
    <CommonXPageNav :nav-list="[{ label: $t('订单'), link: '/my/orders/spot' }]" />
    <div class="flex items-center my-4">
      <h1 class="text-2xl font-bold">
        {{ $t('现货订单') }}
      </h1>
    </div>
    <CommonXMod component-class="!px-0 min-h-[400px]" header-class="!px-0 !h-10" :tabs="tabs" :tab="curTab" @tab-change="tabChange">
      <template v-if="route.params.type !== 'record'" #prefix>
        <OrdersOrderSelects class="my-4" :selects="selects[curTab]" @search="handleSearch" />
      </template>
    </CommonXMod>
  </div>
</template>
